export default {
  presets: {
    light: {
      backgroundPrimary: '#f2f3f5',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: 'rgba(237, 247, 237, 1)',
      info: '#158DE3',
      danger: 'rgba(170, 37, 70, 1)',
      warning: '#FFD43A',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
  currentPresetName: 'light',
  variables: {
    primary: 'rgba(13, 54, 146, 1)',
    success: 'rgba(76, 175, 80, 1)',
    warning: 'rgba(255, 153, 0, 1)',
  },
}
